module.exports = __webpack_public_path__ + "static/img/concierce_voucher1.b7ebb9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/concierce_voucher1.png
// module id = VXQn
// module chunks = 0